import { omit } from 'lodash';
import userService from '@/services/UserService';
import addressService from '@/services/AddressService';

const me = {
  state: {
    user: {},
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = { ...state.user, ...payload };
    },
    setUserAddress(state, payload) {
      // if address come from viacep api
      let address;
      if (payload.logradouro) {
        address = {
          street: payload.logradouro,
          complement: payload.complemento,
          neighborhood: payload.bairro,
          city: payload.localidade,
          state: payload.uf,
          zipcode: payload.cep,
        };
      } else {
        address = { ...payload };
      }
      state.user = { ...state.user, address };
    },
    logout(state) {
      state.user = {};
    },
  },
  actions: {
    async getUser({ commit }) {
      const response = await userService.getUser();
      commit('setUser', response.data);
      localStorage.setItem('user', JSON.stringify(response.data));
    },
    updateUser({ commit }, payload) {
      if (payload.avatar && !payload.avatar.url) {
        commit('toggleLoader', { show: true, component: 'UserAvatar' });
      } else if (payload.signature && !payload.signature.url) {
        commit('toggleLoader', { show: true, component: 'UserSignature' });
      } else {
        commit('toggleLoader', { show: true });
      }
      userService.updateUser({ id: payload.userId, data: omit(payload, ['userId']) })
        .then(() => {
          commit('toggleSnackbar', {
            show: true,
            timeout: 6000,
            color: 'success',
            message: 'Usuário atualizado com sucesso!',
            messageIcon: 'mdi-check',
          });
          if (payload.avatar && !payload.avatar.url) {
            commit('setUser', { avatar: { url: payload.avatar } });
          }
          if (payload.signature && !payload.signature.url) {
            commit('setUser', { signature: { url: payload.signature } });
          }
          commit('toggleLoader', { show: false });
        })
        .catch((error) => {
          commit('toggleSnackbar', {
            show: true,
            timeout: 6000,
            color: 'error',
            message: error.message,
            messageIcon: 'mdi-alert-outline',
          });
          commit('toggleLoader', { show: false });
        });
    },
    getUserCepAddress({ commit }, payload) {
      commit('toggleLoader', { show: true });
      addressService.searchZipCode(payload)
      .then((response) => {
        response.json()
          .then((result) => {
            commit('setUserAddress', result);
            commit('toggleLoader', { show: false });
          });
      })
      .catch((error) => {
        commit('toggleLoader', { show: false });
        commit('toggleSnackbar', {
          show: true,
          timeout: 6000,
          color: 'error',
          message: error.message,
          messageIcon: 'mdi-alert-outline',
        });
      });
    },
    logout({ commit }) {
      commit('logout');
    },
  },
};

export default me;



// WEBPACK FOOTER //
// ./src/vuex/account/me.js